// extracted by mini-css-extract-plugin
module.exports = {"tooltip_icon":"style_tooltip_icon__J-rPw","tooltip":"style_tooltip__sjg9d","tooltiptext":"style_tooltiptext__1FUjw"};